<!-- 审核账户信息 -->
<script setup>
import i18n from "@/i18n"
import { useRoute, useRouter, } from "vue-router";
// import QRCode from "qrcode";
import { onMounted, ref, provide, watch, onUnmounted, nextTick } from "vue"
import moment from "moment"
import productInfoCom from "./components/info/productInfo.vue"; //产品信息
import comfortInformationCom from "./components/info/comfortInformation.vue"; //产品信息
import indicatorstandardsCom from "./components/info/indicatorstandards.vue"; //产品信息
// import qualityInspectionReportCom from "./components/info/qualityInspectionReport.vue";
import otherInfoCom from "./components/info/otherInfo.vue"; //其他信息
// import { starUI } from "@/utils/common";
import { showMessage } from "@/utils/hooks/message"
import rejectSvg from "@/assets/images/svg/reject.svg"
import nextIcon from "@/assets/images/products/disabled-next.png"
import prevIcon from "@/assets/images/products/disabled-prev.png"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const qrcodeImgUrl = ref('')
const qrcodeImgUrl1 = ref('') // OID
import { getProductDetailV3, getFileUrl, getHscodeDetail, database_template_name_v3 } from "@/service";
import { putBusinessProducts, database_business_review, database_eu_registry } from "@/service/apiList/businessProduct"
import Swal from "sweetalert2";
import PreviewImg from "@/components/common/PreviewImg";
const route = useRoute()
const router = useRouter()
const showWatermark = ref(false) // 是否显示水印logo
const certificationCompany = ref({
    name: '',
    logo: '',
}) // 审核该产品认证公司信息
const PageHeaderT = getLangValue('business-product', "title")
const PageHeaderItems = [
    {
        href: `/business_products_management?search_type=${route.query.search_type || 0}`,
        text: getLangValue('business-product', "title"),
        active: false,
    },
    {
        text: route.query.search_type == 0 ? getLangValue('business-product', "subtitle1") : getLangValue('business-product', "subtitle2"),
        active: true,
    },
]
const detailInfo1 = ref({})
const table_name = ref('')
provide('detailInfo', detailInfo1)
provide('table_name', table_name)
const loading = ref(false) // 加载效果
const groupList = ref({})
const groupList1 = ref([])
const groupList2 = ref([])
const groupList3 = ref([])
const index_standards_list = ref({})
provide('index_standards_list', index_standards_list)
//产品复制信息
const refs = ref([]);
const addRefs = (i) => {
    return (el) => {
        refs.value[i] = el;
    };
}
const imageList = ref([])
const templateNameList = ref([])
provide('templateNameList', templateNameList)
const detailInfo = ref(
    {
        basic_info: {
            name: '',
            hscode: '',
            supplier: '',
            publishTime: '',
            score: 0.7,
            price: '',
            unit: '',
            order: '',
            stocks: '',
            batch: '',
            size: '',
            color: '',
            description: '',
        },
        customer_info: [
            // {
            //     label: '厚度',
            //     value: '3m'
            // },
            // {
            //     label: '厚度',
            //     value: '3m'
            // },
            // {
            //     label: '厚度',
            //     value: '3m'
            // },
            // {
            //     label: '厚度',
            //     value: '3m'
            // }
        ],
    }
)
const imageActiveIndex = ref(0)
const activeImageSrc = ref("")
const showPreviewImg = ref(false)

const switchImg = (i) => {
    imageActiveIndex.value = i
}


const qrcode = async () => {
    // 根据详细信息
    // 现在只展示pid
    if (detailInfo1.value.pid) {
        const reps = await makeQrCode({ type: 2, id: route.query.id }, true)
        if (reps) {
            qrcodeImgUrl.value = reps
        }
    }
    const reps1 = await makeQrCode({ type: 1, id: detailInfo1.value.organization?.id })
    if (reps1) {
        qrcodeImgUrl1.value = reps1
    }
}

const showQrcode = (type) => {
    // 显示图片
    console.log(type);
    activeImageSrc.value = type == 1 ? qrcodeImgUrl1.value : qrcodeImgUrl.value;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const tabList = ref([
    { name: getLangValue("product-template.productInfo"), com: productInfoCom, ref: 'productInfoRef', show: true }, //产品信息组件
    { name: getLangValue("product-template.comfortInformation"), com: comfortInformationCom, ref: 'comfortInformationRef', show: true },
    // { name: i18n.global.t("attribute.indicatorstandards"), com: indicatorstandardsCom, ref: 'indicatorstandardsRef', show: true },
    // { name: i18n.global.t("product_template.qualityInspectionReport"), com: qualityInspectionReportCom, ref: 'qualityInspectionReportRef', show: true },
    { name: getLangValue("product-template.otherInfo"), com: otherInfoCom, ref: 'otherInfoRef', show: true },
])
const current_tab = ref(0)
provide('tabList', tabList)
provide('current_tab', current_tab)
/** tab部分 */
const handlerToggleTab = (i, id) => {
    current_tab.value = i
    if (id) {
        refs.value[i].current_tab = id
    }
}
/** tab部分 */

//methods
const prev = () => {
    //上一页
    if (imageActiveIndex.value === 0) {
        imageActiveIndex.value = imageList.value.length - 1
    } else {
        imageActiveIndex.value--
    }
}

const next = () => {
    //下一页
    if (imageActiveIndex.value === imageList.value.length - 1) {
        imageActiveIndex.value = 0
    } else {
        imageActiveIndex.value++
    }
}

const getHscodeDetai1l = async (id) => {
    const reps = await getHscodeDetail(id, { ignore_fields: '["index_standards"]' });
    if (reps) {
        return i18n.global.locale == 'en' ? reps.payload?.title_en : reps.payload?.title
    }
}

const handler = (index) => {
    /**操作 */
    switch (index) {
        case 0:
            // 不通过
            // 是否需要信息
            rejectProduct()
            break;
        case 1:
            // 检测通过
            passProduct(1)
            break;
        default:
            // 认证通过
            passProduct(2)
            break;
    }
}

const rejectProduct = async () => {
    /**驳回信息 */
    let checkRes = true
    if (checkRes)
        Swal.fire({
            title: getLangValue('business-product', "reject_reason"),
            input: "textarea",
            inputValue: '',
            showCancelButton: true,
            confirmButtonText: getLangValue("base.done"),
            cancelButtonText: getLangValue("base.cancel"),
            showLoaderOnConfirm: true,
            confirmButtonColor: "#0AB39c",
            cancelButtonColor: "#f06548",
            inputValidator: (value) => {
                if (!value) {
                    return getLangValue('business-product', "input_reject_reason")
                }
            },
            preConfirm: async (value) => {
                if (value) {
                    let params = {
                        status: 3,
                        description: value,
                    }
                    const resp = await putBusinessProducts(route.query.id, params)
                    if (resp.code == 0) {
                        //执行成功
                        showMessage('success', getLangValue('business-product', 'rejectedsuccessfully'))
                        setTimeout(() => {
                            router.push({ path: '/business_products_management', query: { search_type: route.query.search_type || 0 } })
                        }, 2000)
                    } else {
                        showMessage('danger', resp.message)
                    }
                }
            },
            allowOutsideClick: false,
        }).then((text) => {
            console.log(text);
        });

}

const getProductUrl = () => {
    let href = window.location.href
    let arr = href.split('/#/')
    let website = arr[0]
    let lang = i18n.global.locale;
    let token = ''
    let timestamp = '';
    let storeData = sessionStorage.getItem('set_menu_list');
    if (storeData) {
        storeData = JSON.parse(storeData)
        token = storeData.token;
        timestamp = storeData.timestamp;
    }
    //website 转换为htts
    website = website.replace(/^http:\/\//i, 'https://')

    if (!/^https:\/\//i.test(website)) {
        website = 'https://' + website
    }
    return `${website}/#/passwort/${route.query.id}?lang=${lang}&token=${token}&timestamp=${timestamp}&is_public=1`
}

const euRegistry = async () => {
    /**提交到欧盟 */
    let params = {
        "database_id": route.query.id,
        "reoId": detailInfo1.value.pid,
        "upi": `FBD${detailInfo1.value.pid}`,
        "liveURL": getProductUrl(),
        "backupURL": getProductUrl(),
        "commodityCode": detailInfo.value.basic_info.hscode,
        "granularityLevel": "ITEM",
        "deactivated": false
    }
    const resp = await database_eu_registry(params)
    if (resp.code != 0) {
        showMessage('danger', resp.message)
    }else{
        showMessage('success', getLangValue('base', 'success'))
        getDetailInfo()
    }
}

const passProduct = async (index) => {
    /**审核通过 */
    let params = {
        status: index
    }
    const resp = await putBusinessProducts(route.query.id, params)
    if (resp.code == 0) {
        // 提交到欧盟
        // await euRegistry()
        //执行成功
        showMessage('success', getLangValue('business-product', 'passed_successfully'))
        router.push({ path: '/business_products_management' })
    } else {
        showMessage('danger', resp.message)
    }
}
const getProductImages = async (data) => {
    let imageIdList = []
    let imageInfo = {}
    const { product_info, quality_inspection_report, extra_info, comfort_info } = data
    // 获取产品信息里面的图片
    // const upList = product_info.children.filter(item => (item.key == '产品图片' || item.key == "2D版型" || item.key == "虚拟合身度") && item.show)
    const upList = product_info.children.filter(item => (item.key == 'product_info_product_picture' || item.key == 'product_info_product_style' || item.key == 'product_info_product_pattern' || item.key == 'product_info_virtual_fit' || item.key == 'product_trademark') && item.show)
    if (upList.length) {
        upList.forEach((item) => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    const csFieldList = product_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (csFieldList.length) {
        csFieldList.forEach(item => {
            if (item.value && item.value != null && item.value.length) {
                imageIdList = [...imageIdList, ...item.value]
            }
        })
    }
    // // 舒适度信息
    // const heList = comfort_info.children.filter(item => item.show && item.key == "热湿舒适度")
    // if (heList.length) {
    //     if (heList[0].value && heList[0].value.length) {
    //         imageIdList = [...imageIdList, ...heList[0].value]
    //     }
    // }
    const cfList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    // console.log(comfort_info.children)
    if (cfList.length) {
        cfList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }

    // const csFList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && !item.extra.uukey)
    // if (csFList.length) {
    //     csFList.forEach(item => {
    //         if (item.value && item.value != null && item.value.length)
    //             imageIdList = [...imageIdList, ...item.value]
    //     })
    // }
    // 原来的质检报告
    // if (quality_inspection_report && quality_inspection_report.show) {
    //     if (quality_inspection_report.value && quality_inspection_report.value.length) {
    //         imageIdList = [...imageIdList, ...quality_inspection_report.value]
    //     }
    // }
    // 新的报告信息
    const reportList = quality_inspection_report.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (reportList.length) {
        reportList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    // 其他信息
    const etrList = extra_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    // console.log(extra_info.children)
    if (etrList.length) {
        etrList.forEach(item => {
            if (item.value && item.value != null && item.value.length)
                imageIdList = [...imageIdList, ...item.value]
        })
    }
    imageIdList = [...new Set(imageIdList)]
    if (imageIdList.length) {
        let ids = imageIdList.join(",")
        const res = await getFileUrl({ attachments: ids })
        if (res)
            res.payload.forEach(item => {
                item.filename = item.name
                item.type = setType(item.filename)
                imageInfo[item.id] = item
            })
    }
    return imageInfo
}
const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    }
    return 'file'
}
const getValueByKey = (children, key, valueKey = 'value') => {
    // 通过key来获取  不通过index 顺序修改了会报错
    if (children) {
        let obj = children.find(item => item.key == key)
        if (valueKey == 'extra') { // 生产时间特殊一点
            return obj ? (obj[valueKey]) : ''
        }
        return obj ? (obj[valueKey] + (obj.extra && obj.extra[valueKey] ? obj.extra[valueKey] : '')) : ''
    }
    return ''
}

const getValueByKey1 = (children, key, valueKey = 'value') => {
    // 通过key来获取  不通过index 顺序修改了会报错
    if (children) {
        let obj = children.find(item => item.key == key)
        return obj ? (obj[valueKey]) : ''
    }
    return ''
}
const getTemplateNameList = async () => {
    // 全量模板列表
    const resp = await database_template_name_v3()
    if (resp.code == 0) {
        templateNameList.value = resp.payload;
        // console.log(templateNameList.value);
    }
}

const getDetailInfo = async () => {
    // 获取详情信息
    loading.value = true
    await getTemplateNameList();
    table_name.value = route.query.t_name
    try {
        const resp = await getProductDetailV3(route.query.id)
        if (resp) {
            if (resp.code == 1) {
                showMessage('danger', resp.message)
                loading.value = false
                return;
            }
            //设置信息a
            // console.log(resp.payload)
            //图片信息
            const { product_info } = resp.payload
            const { template_info } = resp.payload
            const upList = product_info.children.filter(item => (item.key == ('product_info_product_picture')) && item.show)
            if (upList.length && upList[0].value != null && upList[0].value.length) {
                // 获取数据
                let ids = upList[0].value.join(',')
                getFileUrl({ attachments: ids }).then(res => {
                    res.payload.map(item => {
                        item.filename = item.name
                    })
                    imageList.value = res.payload
                })
            }
            //基本信息
            const basiInofo = product_info.children.find(item => item.key == 'product_info_base_info')
            detailInfo.value.basic_info.name = getValueByKey(basiInofo.children, 'product_info_base_info_product_name')
            let hscodeValue = getValueByKey1(template_info.children, 'template_info_hscode')
            detailInfo.value.basic_info.hscode = await getHscodeDetai1l(hscodeValue) //处理
            detailInfo.value.basic_info.supplier = '暂无' //处理
            detailInfo.value.basic_info.publishTime = resp.payload.create_time
            detailInfo.value.basic_info.start = basiInofo.children[0].value
            detailInfo.value.basic_info.price = getValueByKey(basiInofo.children, 'product_info_base_info_price')
            detailInfo.value.basic_info.price_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_price', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_price', 'name')
            detailInfo.value.basic_info.unit = getValueByKey(basiInofo.children, 'product_info_base_info_price', 'unit')
            detailInfo.value.basic_info.stocksUnit = getValueByKey(basiInofo.children, 'product_info_base_info_inventory_unit',)
            detailInfo.value.basic_info.productTime = getValueByKey(template_info.children, 'template_info_production_time', 'extra')
            detailInfo.value.basic_info.stocks = getValueByKey(basiInofo.children, 'product_info_base_info_inventory')
            detailInfo.value.basic_info.stocks_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_inventory', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_inventory', 'name')
            detailInfo.value.basic_info.batch = getValueByKey(basiInofo.children, 'product_info_base_info_batch_number')
            detailInfo.value.basic_info.batchValue = getValueByKey(basiInofo.children, 'product_info_base_info_batch_size')
            detailInfo.value.basic_info.batchValue_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_batch_size', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_batch_size', 'name')
            detailInfo.value.basic_info.size = getValueByKey(basiInofo.children, 'product_info_base_info_size')
            detailInfo.value.basic_info.size_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_size', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_size', 'name')
            detailInfo.value.basic_info.color_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_color', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_color', 'name')
            detailInfo.value.basic_info.color = getValueByKey(basiInofo.children, 'product_info_base_info_color')
            detailInfo.value.basic_info.description = getValueByKey(basiInofo.children, 'product_info_base_info_description')
            detailInfo.value.basic_info.description_name = i18n.global.locale == 'en' ? getValueByKey(basiInofo.children, 'product_info_base_info_description', 'name_en') : getValueByKey(basiInofo.children, 'product_info_base_info_description', 'name')
            // 自定义信息
            detailInfo.value.customer_info = basiInofo.children.filter(item => (item.extra && item.extra.type == 99) || item.key == 'product_info_base_info_type').map(item => {
                // item.value = item.value
                item.label = item.name
                item.label_en = item.name_en
                return item
            });
            // = product_info.children[1].children.map(item => ({
            //     label: item.label,
            //     value: item.value
            // }))
            // 设置动态指标
            // setInfo(resp.payload.index_standard_info.extra.groupList)
            // index_standards_list.value = {}
            // for (const item in resp.payload.index_standard_info.value) {
            //     index_standards_list.value[item] = {
            //         groupName: item,
            //         indicatorList: resp.payload.index_standard_info.value[item] ? resp.payload.index_standard_info.value[item] : [],
            //     }
            // }
            // 设置动态指标
            setInfo(resp.payload.index_standard_info.value)

            // 设置名称及信息
            //产品信息别名
            tabList.value[0].name = resp.payload.product_info.name
            tabList.value[0].name_en = resp.payload.product_info.name_en
            // 舒适度信息别名
            tabList.value[1].name = resp.payload.comfort_info.name
            tabList.value[1].name_en = resp.payload.comfort_info.name_en
            tabList.value[1].show = resp.payload.comfort_info.show
            // 指标信息别名
            // tabList.value[2].show = resp.payload.index_standard_info.show
            // tabList.value[2].name = resp.payload.index_standard_info.name
            // 报告别名
            // tabList.value[3].show = resp.payload.quality_inspection_report.show
            // tabList.value[3].name = resp.payload.quality_inspection_report.name
            // 其他信息
            tabList.value[tabList.value.length - 1].show = resp.payload.extra_info.show
            tabList.value[tabList.value.length - 1].name = resp.payload.extra_info.name
            tabList.value[tabList.value.length - 1].name_en = resp.payload.extra_info.name_en
            // 获取所有图片
            const imageInfo = await getProductImages(resp.payload);
            // 其他信息通过provide inject处理
            resp.payload.imageInfo = imageInfo
            detailInfo1.value = resp.payload
            //二维码
            qrcode();
            if (detailInfo1.value.status == 3 && detailInfo1.value.sub_status === 0) {
                showRejectInfo()
            }
            loading.value = false
            // 浏览量
            if (detailInfo1.value.views != null) {
                nextTick(() => {
                    animateNumber(detailInfo1.value.views);
                })
            }
            // 水印图片
            checkProductAndSetLogo(resp.payload)
        }
    } catch (e) {
        console.log(e);
        loading.value = false
    }

}

const checkProductAndSetLogo = async (data) => {
    // 检测产品装填是否认证通过
    // 他如果是认证通过就显示水印logo
    // 获取信息
    if (data.certification_user) {
        // 获取图片
        if (data.certification_user.company_logo) {
            const resp = await getFileUrl({ attachments: data.certification_user.company_logo })
            certificationCompany.value = {
                name: data.certification_user.company_name,
                logo: resp.payload[0] ? resp.payload[0].url : '',
            }
            showWatermark.value = true
        } else {
            certificationCompany.value = {
                name: data.certification_user.company_name,
                logo: '',
            }
            showWatermark.value = false
        }

    }
}
const setInfo = (index_standard_info) => {
    // 倒叙
    // index_standard_info = index_standard_info.reverse();
    tabList.value = [
        { name: '产品信息', com: productInfoCom, ref: 'productInfoRef', show: true, canEdit: true, }, //产品信息组件
        { name: '舒适度信息', com: comfortInformationCom, ref: 'comfortInformationRef', show: true, canEdit: true, },
        // { name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, },
    ]
    if (index_standard_info !== null) {
        groupList1.value = []
        groupList2.value = []
        groupList3.value = []
        let category_name_info = {}; // 存储他的类型
        for (let k in index_standard_info) {
            //在这里处理多层数据 用不同的key
            const { children, group_name, group_name_en, index_standards } = index_standard_info[k]
            groupList1.value.push({
                name: group_name,
                name_en: group_name_en,
                id: `group_${k}`,
            });
            let m = {
                groupName: k,
                indicatorList: index_standards ? index_standards : [],
            }
            category_name_info[`group_${k}`] = '';
            category_name_info[`group_${k}`] = index_standards.length ? index_standards[0].category_name : category_name_info[`group_${k}`]; // 有可能有  有可能没有
            index_standards_list.value[`group_${k}`] = m
            // 第二级
            if (children.length) {
                for (let kk in children) {
                    const { children: children1, group_name: group_name1, group_name_en: group_name1_en } = children[kk]
                    groupList2.value.push({
                        name: group_name1,
                        name_en: group_name1_en,
                        id: `group_${k}_${kk}`
                    });
                    let m = {
                        groupName: k,
                        indicatorList: children[kk].index_standards ? children[kk].index_standards : [],
                    }
                    category_name_info[`group_${k}`] = children[kk].index_standards.length ? children[kk].index_standards[0].category_name : category_name_info[`group_${k}`];
                    index_standards_list.value[`group_${k}_${kk}`] = m
                    // 第三级
                    if (children1.length) {
                        // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                        for (const item3 in children1) {
                            // console.log(item3);
                            const { group_name: group_name2, group_name_en: group_name2_en, index_standards: index_standards2 } = children1[item3]
                            groupList3.value.push({
                                name: group_name2,
                                name_en: group_name2_en,
                                id: `group_${k}_${kk}_${item3}`
                            });
                            let m = {
                                groupName: item3,
                                indicatorList: index_standards2 ? index_standards2 : [],
                            }
                            category_name_info[`group_${k}`] = index_standards2.length ? index_standards2[0].category_name : category_name_info[`group_${k}`];
                            index_standards_list.value[`group_${k}_${kk}_${item3}`] = m
                        }
                    }
                }

            }
        }
        groupList.value = {
            groupList1: groupList1.value,
            groupList2: groupList2.value,
            groupList3: groupList3.value,
            category_name_info
        }
        // 如果group1大于0
        if (groupList1.value.length) {
            for (const item in groupList1.value) {
                tabList.value.push({
                    name: groupList1.value[item].name,
                    name_en: groupList1.value[item].name_en,
                    type: 'instandard',
                    show: true,
                    canEdit: false,
                    id: groupList1.value[item].id,
                })
            }
        }
        tabList.value.push({ name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, })
    }
}

// const setInfo = (groupList_val) => {
//     // console.log(groupList_val);
//     tabList.value = [
//         { name: '产品信息', com: productInfoCom, ref: 'productInfoRef', show: true, canEdit: true, }, //产品信息组件
//         { name: '舒适度信息', com: comfortInformationCom, ref: 'comfortInformationRef', show: true, canEdit: true, },
//         // { name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, },
//     ]
//     groupList.value = { ...groupList_val }
//     groupList1.value = groupList.value.groupList1
//     groupList2.value = groupList.value.groupList2
//     groupList3.value = groupList.value.groupList3
//     if (groupList1.value.length) {
//         for (const item in groupList1.value) {
//             tabList.value.push({
//                 name: groupList1.value[item].name,
//                 type: 'instandard',
//                 show: true,
//                 canEdit: false,
//                 id: groupList1.value[item].id,
//             })
//         }
//     }
//     tabList.value.push({ name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, })
// }

const showRejectInfo = async () => {
    // 显示驳回信息
    // console.log(detailInfo1.value.database_list_id);
    const resp = await database_business_review(detailInfo1.value.database_list_id, { status: 3 })
    if (resp.code == 0) {
        let description = resp.payload.length ? resp.payload.pop().description : getLangValue('base.no_data')
        // console.log(description);
        Swal.fire({
            width: '400px',
            html: `<div style="height:200px">
            <div class='my-title p-2' style='background-color: #4A6372;color:white;font-size:14px; font-weight:bold;text-align:left'>${getLangValue('business-product', 'reject_reason')}</div>
                <div style='text-align:left;line-height:22px; font-size:13px' class='p-2'>
                    ${description}
                </div>
            </div>`,
            customClass: {
                popup: 'my-container',
            },
            showConfirmButton: true,
            confirmButtonText: getLangValue('base.confirm'),
            confirmButtonColor: '#405189',
            // confirmButtonTextColor: '#fff',
        });
    } else {
        showMessage('danger', resp.message);
    }
}

const scrollToElement = (elementId) => {
    // 滚动到指定元素
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    }
}

// 累加数字
const animateNumber = (target) => {
    // 使用函数
    const element = document.getElementById('page_view');
    let current = 0;
    const increment = Math.ceil(target / 10); // 每次增加的数值，可以根据需要调整
    const interval = setInterval(() => {
        current += increment;
        if (current >= target) {
            current = target;
            clearInterval(interval);
        }
        element.textContent = current;
    }, 100); // 更新频率，可以根据需要调整
}
// const handleResize = () => {
//     // let dom = document.getElementById('imageList')
//     // if (dom)
//     //     dom.style.height = dom.clientWidth + 'px'
//     // // shezhi
//     // let switchImageDoms = document.getElementsByClassName('switchImage')
//     // for (let i = 0; i < switchImageDoms.length; i++) {
//     //     switchImageDoms[i].style.height = switchImageDoms[i].clientWidth + 'px'
//     // }
// }
// 轮播图切换 滚动
watch(imageActiveIndex, (val) => {
    scrollToElement(`switchImage${val}`)
})
// 路由切换  需要刷新
watch(route, () => {
    window.location.reload()
}, { deep: true })

onMounted(() => {
    getDetailInfo()
    // 窗口宽度监听
    // window.addEventListener('resize', handleResize);
    // console.log(route.query.search_type == 0);
})


onUnmounted(() => {
    // window.removeEventListener('resize', handleResize);
});
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <!-- <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);"
            class="my-detail bg-white product-detail d-flex p-3 "> -->
        <div class="card bg-white product-detail d-flex p-3 " style="min-height: calc(100vh - 140px);"
            v-loading="loading">
            <div class="d-flex" style="flex-direction: unset;">
                <div class="imageList" style="position: sticky; top:20px">
                    <div class="image-full">
                        <!-- With Controls -->
                        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel"
                            data-bs-interval="false" style="height: 100%;">
                            <div class="carousel-inner" role="listbox" v-if="imageList.length"
                                style="border-radius: 6px;height: 100%;">
                                <div style="height: 100%;" class="carousel-item"
                                    :class="key == imageActiveIndex ? 'active' : ''" v-for="(item, key) in imageList"
                                    :key="key">
                                    <img class="d-block  mx-auto" :src="item?.url" alt="First slide">
                                </div>
                            </div>
                            <Empty v-else
                                style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
                                :flag="1"></Empty>
                            <a class="carousel-control-prev">
                                <div style="width: 32px; height: 32px; background-color: #d0d5e1; border-radius: 10px;"
                                    class="d-flex align-items-center justify-content-center cursor-pointer"
                                    @click="prev">
                                    <i class=" ri-arrow-left-s-line" aria-hidden="true"
                                        style="color: #405189; font-size: 28px;"></i>
                                </div>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next">
                                <div style="width: 32px; height: 32px; background-color: #d0d5e1; border-radius: 10px;"
                                    class="d-flex align-items-center justify-content-center cursor-pointer"
                                    @click="next">
                                    <i class=" ri-arrow-right-s-line" aria-hidden="true"
                                        style="color: #405189; font-size: 28px;"></i>
                                </div>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                    <!-- <div class="image-tab my-2 my-scroll-bar"
                    style="overflow-x: auto; overflow-y: hidden;box-sizing: border-box; margin: 0; padding: 0; white-space: nowrap;">
                    <div class="switchImage mx-2"
                        :id="`switchImage${key}`"
                        style="
                        width: 110px;
                        height: 100%;
                        display: inline-block;
                        border-radius: 10px;
                        padding: 0px;" v-for="(item, key) in imageList" :key="key"
                        :class="key == imageActiveIndex ? 'active' : ''">
                        <img @click="switchImg(key)" class="d-block  mx-auto cursor-pointer" :src="item.url"
                            alt="First slide">
                    </div>
                </div> -->
                    <div class="image-tab my-2 d-flex align-items-center">
                        <div style="width: 35px; display: inline-block;" v-if="imageList.length > 4">
                            <img :src="prevIcon" style="width: 22px;" @click="prev" class="cursor-pointer">
                        </div>
                        <div class="px-2"
                            style="overflow: hidden;box-sizing: border-box; margin: 0 auto; padding: 0; white-space: nowrap; flex: 1;">
                            <div class="switchImage mx-2" :id="`switchImage${key}`" style="
                        width: 80px;
                        height: 80px;
                        display: inline-block;
                        border-radius: 10px;
                        padding: 0px;" v-for="(item, key) in imageList" :key="key"
                                :class="key == imageActiveIndex ? 'active' : ''">
                                <img @click="switchImg(key)" class="d-block  mx-auto cursor-pointer" :src="item?.url"
                                    alt="First slide">
                            </div>
                        </div>
                        <div style="width:35px;display: inline-block; text-align: right;" v-if="imageList.length > 4">
                            <img :src="nextIcon" style="width: 22px;" @click="next" class="cursor-pointer">
                        </div>
                    </div>
                </div>
                <div class="basicInfo" style="flex:4; overflow-y: auto; overflow-x: hidden;">
                    <div class="basicInfo-detail d-flex" style="flex-direction: column;">
                        <!-- 按钮部分 -->
                        <div style="text-align: right;"
                            v-if="route.query.search_type == 0 && (detailInfo1.status === 0 || (detailInfo1.status !== 0 && detailInfo1.sub_status !== 0))">
                            <b-button v-permit="'business-product.review'" variant="success" @click="handler(0)"
                                style="min-width: 100px; background-color: #299CDB; ">
                                <div class="d-flex align-items-center justify-content-center">
                                    <img :src="rejectSvg" style="width: 16px;" />
                                    {{ getLangValue('business-product', 'reject') }}
                                </div>
                            </b-button>
                            <b-button v-permit="'business-product.review'" variant="success" @click="handler(1)"
                                class="mx-4" style="min-width: 100px; background-color: #299CDB; ">
                                <div class="d-flex align-items-center justify-content-center">
                                    <i class="bx bx-check-circle" style="font-size: 16px;"></i>{{
                                        getLangValue('business-product', 'testedSuccessfully') }}
                                </div>
                            </b-button>
                            <!-- <b-button v-permit="'business-product.review'" variant="success" @click="handler(2)"
                                class="me-2" style="min-width: 100px; background-color: #299CDB; ">
                                <div class="d-flex align-items-center justify-content-center">
                                    <i class="bx bx-check-shield " style="font-size: 16px;"></i>{{
                                        getLangValue('business-product', 'certificationPassed') }}
                                </div>
                            </b-button> -->
                            
                        </div>
                        <div style="text-align: right;"
                            v-if="route.query.search_type == 1 && (detailInfo1.status === 1 && detailInfo1.sub_status === 0)">
                            <b-button v-permit="'business-product.review'" variant="success" @click="handler(0)"
                                style="min-width: 100px; background-color: #299CDB; " class="mx-4">
                                <div class="d-flex align-items-center justify-content-center">
                                    <img :src="rejectSvg" style="width: 16px;" />
                                    {{ getLangValue('business-product', 'reject') }}
                                </div>
                            </b-button>
                            <b-button v-permit="'business-product.review'" variant="success" @click="handler(2)"
                                class="me-6" style="min-width: 100px; background-color: #299CDB; z-index: 100;">
                                <div class="d-flex align-items-center justify-content-center">
                                    <i class="bx bx-check-shield " style="font-size: 16px;"></i>{{
                                        getLangValue('business-product', 'certificationPassed') }}
                                </div>
                            </b-button>
                            
                        </div>
                        <div style="text-align: right; padding-right: 100px; "
                            v-if="detailInfo1.status == 2 && detailInfo1.sub_status === 0">
                            <b-button v-permit="'business-product.review'" variant="success" @click="euRegistry"
                                class="me-2" style="min-width: 100px; background-color: #299CDB; ">
                                <div class="d-flex align-items-center justify-content-center">
                                    <i class="bx bx-check-shield " style="font-size: 16px;"></i>{{
                                        getLangValue('business-product', 'euRegistry') }}
                                </div>
                            </b-button>
                        </div>
                        <div class="d-flex" style="min-height: 75px; flex: 1;flex-wrap: wrap; ">
                            <div style="min-width: 60px;" class="me-2 d-flex">
                                <div class="me-1 cursor-pointer" @click="showQrcode(1)">
                                    <img :src="qrcodeImgUrl1" style="width: 60px; height: 60px;">
                                    <div style="text-align: center;">{{ getLangValue('product-management', "code_oid")
                                        }}
                                    </div>
                                </div>
                                <div class="cursor-pointer" @click="showQrcode(2)">
                                    <img :src="qrcodeImgUrl" style="width: 60px; height: 60px;">
                                    <div style="text-align: center;">{{ getLangValue('product-management',
                                        "code_pid_gtin") }}</div>
                                </div>
                            </div>
                            <div class="title">
                                <h4 style="color:#495057; font-size: 19.5px;">
                                    {{ detailInfo.basic_info.name }}</h4>
                                <div class="d-flex justify-content-between my-2" style=" flex-wrap: wrap;z-index: 2;">
                                    <div class="info pe-2" style="justify-content: start;"><span>HS Code<span
                                                class="mx-1">:</span></span><span style="color: #405189;">{{
                                                    detailInfo.basic_info.hscode }}</span></div>
                                    <div class="info pe-2 d-flex" style="flex-wrap: wrap; ">
                                        <span>{{ getLangValue('hscode.target_market') }}<span
                                                class="mx-1">:</span></span>{{
                                                    i18n.global.locale == 'en' ?
                                                        detailInfo1.production_line?.database_template?.destination_market?.title_en
                                                        : detailInfo1.production_line?.database_template?.destination_market?.title }}
                                    </div>
                                    <div class="info pe-2">
                                        <span>{{ getLangValue('product-management', 'supplier') }}<span
                                                class="mx-1">:</span></span>{{
                                                    detailInfo1.organization ? detailInfo1.organization.company_name : '' }}
                                    </div>
                                    <div class="info pe-2 d-flex" style="flex-wrap: wrap;">
                                        <span>{{ getLangValue('product-template', 'batch') }}<span
                                                class="mx-1">:</span></span>{{
                                                    detailInfo.basic_info.batch }}
                                    </div>
                                    <div class="info pe-2 mx-2">
                                        <span>{{ getLangValue('product-management', "pubnishTime") }}<span
                                                class="mx-1">:</span></span>
                                        {{ i18n.global.locale == 'en' ?
                                            moment(detailInfo.basic_info.publishTime).locale("en").format("DD MMMM,YYYY") :
                                            moment(detailInfo.basic_info.publishTime).format("YYYY-MM-DD")
                                        }}
                                        <!-- {{ dateFormat1(detailInfo.basic_info.publishTime, 'YYYY-MM-DD') }} -->
                                    </div>
                                    <!-- </div> -->
                                </div>
                                <div>
                                    <span style="color: #9599AD;">{{  getLangValue('product-management', "eu_pigital_product _passport_registry_id")   }}:</span>
                                    {{  detailInfo1.eu_registry_id }}
                                     <span style="color: #9599AD;">{{  getLangValue('product-management', "eu_pigital_product _passport_registry_date")   }}:</span>
                                    {{  detailInfo1.eu_registry_date }}
                                     <span style="color: #9599AD;">{{  getLangValue('product-management', "eu_pigital_product _passport_update_date")   }}:</span>
                                    {{  detailInfo1.eu_registry_update_date }}
                                </div>
                            </div>
                            <div class="code d-flex justify-content-end "
                                style="position:absolute; right: 2px; top:-2px; opacity: 0.6">
                                <!-- <div style="width: 60px;">
                                <img :src="qrcodeImgUrl[0] ? qrcodeImgUrl[0] : ''" width="60">
                                <div style="text-align: center;font-size: 10px;">OID</div>
                            </div>
                            <div style="width: 60px;">
                                <img :src="qrcodeImgUrl[1] ? qrcodeImgUrl[1] : ''" width="60">
                                <div style="text-align: center;font-size: 10px;">PLID</div>
                            </div>
                            <div style="width: 60px;">
                                <img :src="qrcodeImgUrl[2] ? qrcodeImgUrl[2] : ''" width="60">
                                <div style="text-align: center;font-size: 10px;">PID</div>
                            </div> -->
                                <!-- sub_status===0 代表审核过后没有进行其他操作 -->
                                <div class="stamp stmp_basic" v-if="detailInfo1.status == 1 && detailInfo1.sub_status === 0">
                                    <div class="inner-circle"></div>
                                    <div class="text" style="font-size: 12px;">{{
                                        getLangValue('business-product', 'testedSuccessfully') }}
                                    </div>
                                    <div class="arc"></div>
                                    <div class="arc arc-bottom"></div>
                                    <div class="stars">
                                        <div class="star star-1"></div>
                                        <div class="star star-2"></div>
                                        <div class="star star-3"></div>
                                        <div class="star star-4"></div>
                                        <div class="star star-5"></div>
                                        <div class="star star-6"></div>
                                        <div class="star star-7"></div>
                                        <div class="star star-8"></div>
                                    </div>
                                </div>
                                <div class="stamp1 stmp_basic" v-if="detailInfo1.status == 2 && detailInfo1.sub_status === 0"
                                    :title="certificationCompany.name">
                                    <!-- 显示认证机构logo -->
                                    <div class=" watermark w-100 h-100" v-if="showWatermark">
                                        <img :src="certificationCompany.logo">
                                        <div class="text" style="font-size: 13px;">
                                            {{ getLangValue("business-product", 'certificationPassed') }}</div>
                                    </div>
                                    <!-- 显示原来的认证信息 -->
                                    <template v-else>
                                        <div class="inner-circle"></div>
                                        <div class="text" style="font-size: 13px;">
                                            {{ getLangValue("business-product", 'certificationPassed') }}</div>
                                        <div class="arc"></div>
                                        <div class="arc arc-bottom"></div>
                                        <div class="stars">
                                            <div class="star star-1"></div>
                                            <div class="star star-2"></div>
                                            <div class="star star-3"></div>
                                            <div class="star star-4"></div>
                                            <div class="star star-5"></div>
                                            <div class="star star-6"></div>
                                            <div class="star star-7"></div>
                                            <div class="star star-8"></div>
                                        </div>
                                    </template>
                                </div>
                                <div class="stamp2 stmp_basic" v-if="detailInfo1.status == 3 && detailInfo1.sub_status === 0">
                                    <div class="inner-circle"></div>
                                    <div class="text" style="font-size: 13px;">
                                        {{ getLangValue('business-product', 'tab2') }}</div>
                                    <div class="arc"></div>
                                    <div class="arc arc-bottom"></div>
                                    <div class="stars">
                                        <div class="star star-1"></div>
                                        <div class="star star-2"></div>
                                        <div class="star star-3"></div>
                                        <div class="star star-4"></div>
                                        <div class="star star-5"></div>
                                        <div class="star star-6"></div>
                                        <div class="star star-7"></div>
                                        <div class="star star-8"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 评分 -->
                        <!-- <div class="rate d-flex align-items-center">
                        <i v-for="(cls, idx) in starUI(detailInfo.basic_info.score)" :key="idx" :class="cls"
                            style="color: #F7B84B; "></i>
                        <span style="color: #9599AD; font-size: 13px;">( 5.50k {{ $t("products.customerReview") }}
                            )</span>
                    </div> -->
                        <!-- 价格信息... -->
                        <div class="price my-4 d-flex justify-content-around">
                            <div style="flex:1; border: 1px dashed #E9EBEC;border-radius: 4px; height: auto;"
                                class="p-2">
                                <div class="d-flex align-items-center h-100" style="color: #0AB39C;">
                                    <i v-if="detailInfo.basic_info.unit == '¥'" class="ri-money-cny-circle-fill mx-3"
                                        style="font-size: 24px;"></i>
                                    <i v-else-if="detailInfo.basic_info.unit == '€'"
                                        class="ri-money-euro-circle-fill mx-3" style="font-size: 24px;"></i>
                                    <i v-else-if="detailInfo.basic_info.unit == '£'"
                                        class="ri-money-pound-circle-fill mx-3" style="font-size: 24px;"></i>
                                    <i v-else class="ri-money-dollar-circle-fill mx-3" style="font-size: 24px;"></i>
                                    <!-- ri-money-cny-circle-fill -->
                                    <!-- ri-money-euro-circle-fill -->
                                    <!-- ri-money-pound-circle-fill -->
                                    <div class="d-flex justify-content-between flex-column h-100">
                                        <div style="color:#9599AD">{{ detailInfo.basic_info.price_name }} : </div>
                                        <div style="font-size: 16px; color: #495057;font-weight: bold;">{{
                                            detailInfo.basic_info.price ? detailInfo.basic_info.price : '' }} </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div style="flex:1; border: 1px dashed #E9EBEC;border-radius: 4px;" class="mx-2 p-2">
                            <div class="d-flex align-items-center" style="color: #0AB39C;">
                                <i class=" ri-file-copy-2-fill mx-3" style="font-size: 24px;"></i>
                                <div>
                                    <div style="color:#9599AD">{{ $t("products.order") }}：</div>
                                    <div style="font-size: 16px; color: #495057;font-weight: bold;">
                                        {{ detailInfo.basic_info.order }}</div>
                                </div>
                            </div>
                        </div> -->
                            <div style="flex:1; border: 1px dashed #E9EBEC;border-radius: 4px; height: auto;"
                                class="mx-2 p-2">
                                <div class="d-flex align-items-center h-100" style="color: #0AB39C;">
                                    <i class=" ri-stack-fill mx-3" style="font-size: 24px;"></i>
                                    <div class="d-flex justify-content-between flex-column h-100">
                                        <div style="color:#9599AD">{{ detailInfo.basic_info.stocks_name }} : </div>
                                        <div style="font-size: 16px; color: #495057;font-weight: bold;">
                                            {{ detailInfo.basic_info.stocks }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="flex:1; border: 1px dashed #E9EBEC;border-radius: 4px; height: auto;"
                                class="p-2 mx-2">
                                <div class="d-flex align-items-center h-100" style="color: #0AB39C;">
                                    <i class="ri-stack-fill mx-3" style="font-size: 24px;"></i>
                                    <div class="d-flex justify-content-between flex-column h-100">
                                        <div style="color:#9599AD">{{ detailInfo.basic_info.batchValue_name }}
                                            : </div>
                                        <div style="font-size: 16px; color: #495057;font-weight: bold;">
                                            {{ detailInfo.basic_info.batchValue }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="flex:1; border: 1px dashed #E9EBEC;border-radius: 4px; height: auto;"
                                class="p-2 mx-2 d-flex align-items-center">
                                <div class="d-flex align-items-center h-100" style="color: #0AB39C;">
                                    <i class="ri-history-fill mx-3" style="font-size: 24px;"></i>
                                    <div class="d-flex justify-content-between flex-column h-100">
                                        <div style="color:#9599AD">{{ getLangValue('product-management', 'page_view') }}
                                            :
                                        </div>
                                        <div style="font-size: 16px; color: #495057;font-weight: bold;" id="page_view">0
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 尺寸信息 -->
                        <div style="height: 60px;" class="d-flex">
                            <div class="d-flex"
                                style="flex:1; flex-direction: column; justify-content: space-around;color: #495057;font-size: 14px;">
                                <div class="my-1">{{ detailInfo.basic_info.size_name }} :</div>
                                <div class="d-flex" v-if="detailInfo.basic_info.size">
                                    <div class="px-2" style="width: auto; height: 32px;
                                    border-radius: 10px; 
                                    background-color: #eceef3;
                                     text-align: center; 
                                     line-height: 32px;
                                     margin-right: 0.5rem;
                                      color: #405189;"
                                        v-for="(item, k) in detailInfo.basic_info.size.split(/[,;，、；]+/)" :key="k">
                                        {{ item }}
                                    </div>
                                </div>
                                <span v-else>-</span>
                            </div>
                            <div class="d-flex"
                                style="flex:1; flex-direction: column; justify-content: space-around;color: #495057;font-size: 14px;">
                                <div class="my-1">{{ detailInfo.basic_info.color_name }} :</div>
                                <div v-if="detailInfo.basic_info.color">
                                    <!-- <div style="width: 32px; height: 32px;
                                    border-radius: 100%; 
                                    border-color: #eceef3;
                                    display: flex;
                                     align-items: center; 
                                     justify-content: center;
                                     border: 1px solid #E9EBEC;
                                     line-height: 32px;
                                     margin-right: 0.5rem;" v-for="(item, k) in detailInfo.basic_info.color.split(',')"
                                    :key="k">
                                    <div style="width: 20px; height: 20px;border-radius: 100%;"
                                        :style="{ backgroundColor: item }">{{ item }}</div>
                                </div> -->
                                    {{ detailInfo.basic_info.color }}
                                </div>
                                <span v-else>-</span>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- 产地 -->
                            <div style="min-height: 60px; font-size: 14px;flex:1;" class="my-4">
                                <div style="color:#495057" class="mb-2">{{ getLangValue("product-template", "origin") }}
                                    :</div>
                                <div style="color:#9599AD">
                                    {{
                                        `${detailInfo1.production_line?.place_of_origin?.name}-${detailInfo1.production_line?.place_of_origin?.province}`
                                    }}
                                </div>
                            </div>
                            <!-- 产品描述 -->
                            <div style="min-height: 60px; font-size: 14px;flex:1;" class="my-4">
                                <div style="color:#495057" class="mb-2">
                                    {{ detailInfo.basic_info?.description_name }} :</div>
                                <div style="color:#9599AD" v-if="detailInfo.basic_info.description">
                                    {{ detailInfo.basic_info?.description }}
                                </div>
                                <span v-else>-</span>
                            </div>
                        </div>
                        <!-- 新增的字段信息 -->
                        <div class="mb-4 mt-2">
                            <div style="color:#495057; font-size: 14px;" class="mb-2">{{
                                getLangValue("product-template", "basicInfo")
                                }}:</div>
                            <div style="color:#212529" class="row d-flex justify-content-start">
                                <div class="col-6 my-1 d-flex align-items-center"
                                    v-for="(item, k) in detailInfo.customer_info" :key="k">
                                    <div class="mx-2"
                                        style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                    </div>
                                    <span>{{ i18n.global.locale == 'en' ? item.label_en : item.label }} : {{ item.value
                                    }}</span>
                                </div>
                                <!-- 产品线名称 -->
                                <div class="col-6 my-1 d-flex align-items-center">
                                    <div class="mx-2"
                                        style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                    </div>
                                    <span>{{ getLangValue('my.product-line', 'table_header1') }} : {{
                                        detailInfo1.production_line?.production_line_name }}</span>
                                </div>
                                <!-- 产品线编号 -->
                                <div class="col-6 my-1 d-flex align-items-center">
                                    <div class="mx-2"
                                        style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                    </div>
                                    <span>{{ getLangValue('my.product-line', 'table_header') }} : {{
                                        detailInfo1.production_line?.production_line_number }}</span>
                                </div>
                                <!-- 生产时间 -->
                                <div class="col-6 my-1 d-flex align-items-center">
                                    <div class="mx-2"
                                        style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                    </div>
                                    <span>{{ getLangValue('product-template', 'productTime') }} : {{
                                        detailInfo.basic_info.productTime?.value ? i18n.global.locale == 'en' ?
                                            moment(detailInfo.basic_info.productTime?.value).locale("en")
                                                .format("DD MMMM, YYYY hh: mm: ss A") :
                                            moment(detailInfo.basic_info.productTime?.value).format("YYYY-MM-DD hh:mm:ss") :
                                            '-' }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- 产品详情 -->
            <div>
                <span style="color:#495057; font-size: 14px;" class="my-1">{{
                    getLangValue('product-management', 'productdetails') }}</span>
            </div>
            <!-- tab部分 -->
            <ul class="nav nav-tabs nav-tabs-custom nav-success py-0" role="tablist">
                <li class="nav-item" v-for="(tab, i) in tabList" :key="i">
                    <a :class="[
                        'nav-link',
                        'All',
                        'py-3',
                        'position-relative cursor',
                        i == current_tab && 'active',
                    ]" @click="handlerToggleTab(i, tab.id)" v-if="tab.show">{{ i18n.global.locale == 'en' ? tab.name_en
                        : tab.name }}</a>
                </li>
            </ul>
            <!-- tab切换组件 -->
            <template v-for="(tab, i) in tabList" :key="i">
                <!-- <Transition name="myfade"> -->
                <div v-show="i == current_tab">
                    <template v-if="tab.type == 'instandard'">
                        <indicatorstandardsCom :ref="addRefs(i)" :hscodeList="hscodeList" v-show="i == current_tab"
                            :groupList="groupList" :p_id="tab.id" :i_name="tab.name" />
                    </template>
                    <component :is="tab.com" :ref="addRefs(i)" :hscodeList="hscodeList" v-else></component>
                </div>
                <!-- </Transition> -->
            </template>
            <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" v-if="showPreviewImg"
                :myWidth="400">
            </PreviewImg>
        </div>
    </Layout>
</template>

<style scoped lang="scss">
.watermark {
    // opacity: 0.25;
    /* 设置透明度，别太亮 */
    pointer-events: none;
    /* 不影响交互 */
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        z-index: 2;
        transform: rotate(-30deg);
    }
    .text {
        transform: rotate(-40deg);
        z-index: 3;
        opacity: 0.9;
    }
}


.imageList {
    // max-width: 500px;
    // width: 20%;
    // // height: 20vw;
    // max-width: 420px;
    // max-height: 420px;
    // min-width: 250px;
    // min-height: 250px;
    height: 600px;
    width: 470px;

    .image-full {
        width: 470px;
        height: 470px;
        background-color: #F3F6F9;
    }

    .image-tab {
        width: 470px;
        // height: 120px;
        overflow-x: auto;
    }

    .active {
        background-color: #F3F6F9;
    }
}

.stamp {
    width: 100px;
    height: 100px;
    border: 2px solid #add8e6;
    border-radius: 50%;
    position: relative;
    background-color: #fff;

    .inner-circle {
        width: 84px;
        height: 84px;
        border: 1px solid #add8e6;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 8px;
        color: #add8e6;
        font-weight: bold;
        font-family: Arial, sans-serif;
        width: 60px;
        text-align: center;
    }

    .arc {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        border: 1px solid transparent;
        border-top-color: #add8e6;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .arc-bottom {
        transform: translate(-50%, -50%) rotate(180deg);
    }

    .stars {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 0;
        left: 0;
    }

    .star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #add8e6;
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    }

    /* 星星沿弧线的排列 */
    .star-1 {
        top: 8px;
        left: 50%;
        transform: translateX(-50%) rotate(0deg);
    }

    .star-2 {
        top: 18px;
        left: 70px;
        transform: rotate(45deg);
    }

    .star-3 {
        top: 50%;
        left: 80px;
        transform: translateY(-50%) rotate(90deg);
    }

    .star-4 {
        bottom: 20px;
        left: 70px;
        transform: rotate(135deg);
    }

    .star-5 {
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
    }

    .star-6 {
        bottom: 20px;
        right: 70px;
        transform: rotate(225deg);
    }

    .star-7 {
        top: 40%;
        left: 10px;
        transform: rotate(200deg);
    }

    .star-8 {
        top: 15px;
        right: 70px;
        transform: rotate(315deg);
    }
}

.stamp1 {
    width: 100px;
    height: 100px;
    border: 2px solid #8dc8bf;
    border-radius: 50%;
    position: relative;
    background-color: #fff;
    opacity: 0.45;

    .inner-circle {
        width: 84px;
        height: 84px;
        border: 1px solid #8dc8bf;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 8px;
        color: #8dc8bf;
        font-weight: bold;
        font-family: Arial, sans-serif;
        width: 60px;
        text-align: center;
    }

    .arc {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        border: 1px solid transparent;
        border-top-color: #8dc8bf;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .arc-bottom {
        transform: translate(-50%, -50%) rotate(180deg);
    }

    .stars {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 0;
        left: 0;
    }

    .star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #8dc8bf;
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    }

    /* 星星沿弧线的排列 */
    .star-1 {
        top: 8px;
        left: 50%;
        transform: translateX(-50%) rotate(0deg);
    }

    .star-2 {
        top: 18px;
        left: 70px;
        transform: rotate(45deg);
    }

    .star-3 {
        top: 50%;
        left: 80px;
        transform: translateY(-50%) rotate(90deg);
    }

    .star-4 {
        bottom: 20px;
        left: 70px;
        transform: rotate(135deg);
    }

    .star-5 {
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
    }

    .star-6 {
        bottom: 20px;
        right: 70px;
        transform: rotate(225deg);
    }

    .star-7 {
        top: 40%;
        left: 10px;
        transform: rotate(200deg);
    }

    .star-8 {
        top: 15px;
        right: 70px;
        transform: rotate(315deg);
    }
}

.stamp2 {
    width: 100px;
    height: 100px;
    border: 2px solid #DADADA;
    border-radius: 50%;
    position: relative;
    background-color: #fff;

    .inner-circle {
        width: 84px;
        height: 84px;
        border: 1px solid #DADADA;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 8px;
        color: #DADADA;
        font-weight: bold;
        font-family: Arial, sans-serif;
        width: 60px;
        text-align: center;
    }

    .arc {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        border: 1px solid transparent;
        border-top-color: #DADADA;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .arc-bottom {
        transform: translate(-50%, -50%) rotate(180deg);
    }

    .stars {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 0;
        left: 0;
    }

    .star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #DADADA;
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    }

    /* 星星沿弧线的排列 */
    .star-1 {
        top: 8px;
        left: 50%;
        transform: translateX(-50%) rotate(0deg);
    }

    .star-2 {
        top: 18px;
        left: 70px;
        transform: rotate(45deg);
    }

    .star-3 {
        top: 50%;
        left: 80px;
        transform: translateY(-50%) rotate(90deg);
    }

    .star-4 {
        bottom: 20px;
        left: 70px;
        transform: rotate(135deg);
    }

    .star-5 {
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
    }

    .star-6 {
        bottom: 20px;
        right: 70px;
        transform: rotate(225deg);
    }

    .star-7 {
        top: 40%;
        left: 10px;
        transform: rotate(200deg);
    }

    .star-8 {
        top: 15px;
        right: 70px;
        transform: rotate(315deg);
    }
}

.basicInfo {
    margin-left: 30px;

    .title {
        flex: 1;

        .info {
            flex: 1;
            display: flex;
            justify-content: center;

            span {
                color: #9599AD;
                font-size: 13px;
            }

            border-right: 1px solid #9599AD;

            &:last-child {
                border: unset;
            }
        }
    }

    .code {
        // flex: 1;

        img {
            width: 60px;
            height: 60px;
        }
        &:hover {
            opacity: 1 !important;
            .stmp_basic{
                background-color: #313a56;
                opacity: 1;
            }
        }
    }

    .rate {
        height: 20px;

        i {
            font-size: 14px;
        }
    }
}
</style>
<style>
.my-container {
    .swal2-html-container {
        padding: 0 !important;
        margin: 0 !important;
    }

    .swal2-actions {
        margin: 0;
        justify-content: end;
        font-size: 14px;
        padding-right: 10px;
    }
}
</style>